import { useEffect, useState } from "react";
import { io } from "socket.io-client";
import { baseUrl, imgBaseUrl } from "../../utils/constants";
import axios from "axios";
import NoNotifications from "./NoNotifications";
import NotificationsLoader from "./NotificationsLoader";
import { useSelector } from "react-redux";
import { MdDeleteOutline } from "react-icons/md";

const socket = io(imgBaseUrl);

function TabsPanel() {
  const [notifications, setNotifications] = useState([]);
  const [isRead, setIsRead] = useState(false);
  const [isUnRead, setIsUnRead] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const creatorId = useSelector((store) => store?.influencer?.influencer?._id);
  const token = localStorage.getItem("token");

  const fetchNotifications = async (readStatus) => {
    if (!creatorId) return;
    setIsLoading(true);
    try {
      const response = await axios.get(
        `${baseUrl}/creator/notifications/${creatorId}`,
        {
          params: { isRead: readStatus, role: "creator" },
          headers: {
            "auth-token": token,
          },
        }
      );
      setNotifications(response?.data || []);
    } catch (error) {
      console.error("Error fetching notifications:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (read) => {
    setIsRead(read);
    setIsUnRead(!read);
    fetchNotifications(read);
  };

  const markAsRead = async (notificationId) => {
    try {
      await axios.post(
        `${baseUrl}/notification/mark-as-read`,
        {
          notificationId,
        },
        {
          headers: {
            "auth-token": token,
          },
        }
      );
      setNotifications((prev) =>
        prev.filter((notification) => notification._id !== notificationId)
      );
    } catch (error) {
      console.error("Error marking notification as read:", error);
    }
  };

  const timeAgo = (timestamp) => {
    const now = new Date();
    const diffInSeconds = Math.floor((now - new Date(timestamp)) / 1000);

    if (diffInSeconds < 60) return `${diffInSeconds}s ago`;
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) return `${diffInMinutes}m ago`;
    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) return `${diffInHours}h ago`;
    const diffInDays = Math.floor(diffInHours / 24);
    return `${diffInDays} day${diffInDays > 1 ? "s" : ""} ago`;
  };

  useEffect(() => {
    if (!creatorId) return;

    fetchNotifications(false);

    socket.emit("registerCreator", creatorId);

    const notificationHandler = (notification) => {
      setNotifications((prev) => {
        const updated = [notification, ...prev];
        return updated.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
      });
    };

    socket.on("creatorNotification", notificationHandler);

    return () => {
      socket.off("creatorNotification", notificationHandler);
    };
  }, [creatorId]);

  const deleteNotification = async (notificationId) => {
    try {
      await axios.delete(`${baseUrl}/notification/delete/${notificationId}`, {
        headers: {
          "auth-token": token,
        },
      });

      setNotifications((prev) =>
        prev.filter((notification) => notification._id !== notificationId)
      );
    } catch (error) {
      console.error(
        "Error deleting notification:",
        error.response?.data?.message || error.message
      );
      throw error;
    }
  };

  return (
    <>
      <div className="mt-5 tabs_btns">
        <button
          className={isUnRead ? "tab_btn tab_btn_active" : "tab_btn"}
          onClick={() => handleChange(false)}
        >
          Unread
        </button>
        <button
          className={isRead ? "tab_btn tab_btn_active" : "tab_btn"}
          onClick={() => handleChange(true)}
        >
          Read
        </button>
      </div>
      <div className="notifications">
        {isLoading ? (
          <NotificationsLoader />
        ) : notifications.length > 0 ? (
          notifications.map((notification) => (
            <div key={notification._id} className="noti_box">
              <div className="d-flex justify-content-between align-items-center">
                <h3 className="notification_title">Campaign Application</h3>
                <p className="light_text">{timeAgo(notification.createdAt)}</p>
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <p>{notification.message}</p>
                <button
                  className="delete_btn text-danger"
                  onClick={() => deleteNotification(notification._id)}
                >
                  <MdDeleteOutline />
                </button>
              </div>

              {isUnRead && (
                <button
                  className="markRead"
                  onClick={() => markAsRead(notification._id)}
                >
                  Mark as read
                </button>
              )}
            </div>
          ))
        ) : (
          <NoNotifications />
        )}
      </div>
    </>
  );
}

export default TabsPanel;
